import React, { useState } from 'react';
import './Navbar.css';
import logo from '../img/logo.png';

const Navbar = ({ currentPage, onNavigate }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleLinkClick = (pageName, anchor) => {
        setIsOpen(false);
        if (onNavigate) {
            onNavigate(pageName);
        }
        if (anchor) {
            setTimeout(() => {
                const el = document.querySelector(anchor);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <nav className="navbar">
            <div className="nav-logo-container">
                <a 
                    href="#inicio" 
                    onClick={(e) => { e.preventDefault(); handleLinkClick('home', null); }}
                >
                    <img src={logo} alt="3 Vértices Logo" className="nav-logo-img" />
                </a>
            </div>

            <div className={`nav-links-container ${isOpen ? 'is-open' : ''}`}>
                <ul className="nav-links">
                    {currentPage === 'home' ? (
                        <>
                            <li><a href="#servicios" onClick={toggleMenu}>Servicios</a></li>
                            <li><a href="#historia" onClick={toggleMenu}>Acerca de</a></li>
                            <li><a href="#preguntas" onClick={toggleMenu}>FAQ</a></li>
                        </>
                    ) : (
                        <>
                            <li><a href="#inicio" onClick={() => handleLinkClick('home', null)}>Inicio</a></li>
                            <li><a href="#caracteristicas" onClick={() => handleLinkClick('qrmanda', '#caracteristicas')}>Módulos</a></li>
                            <li><a href="#planes" onClick={() => handleLinkClick('qrmanda', '#planes')}>Planes</a></li>
                        </>
                    )}

                    {/* BOTÓN PARA CAMBIAR A LA PÁGINA DE QRMANDA */}
                    <li>
                        <button 
                            type="button" 
                            className={`nav-link-product-btn ${currentPage === 'qrmanda' ? 'active' : ''}`}
                            onClick={() => handleLinkClick('qrmanda', null)}
                        >
                            QRManda
                            <span className="nav-product-badge">NUEVO</span>
                        </button>
                    </li>
                </ul>

                <a 
                    href="#contacto"
                    className="nav-cta-btn"
                    onClick={(e) => {
                        if (currentPage !== 'home') {
                            e.preventDefault();
                            handleLinkClick('home', '#contacto');
                        } else {
                            toggleMenu();
                        }
                    }}
                >
                    Contáctanos
                </a>
            </div>

            <div className={`hamburger ${isOpen ? 'is-active' : ''}`} onClick={toggleMenu} aria-label="Menu">
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
        </nav>
    );
};

export default Navbar;